import { render, staticRenderFns } from "./component-df54bc0c.vue?vue&type=template&id=872f9f52&scoped=true&"
import script from "./component-df54bc0c.vue?vue&type=script&lang=js&"
export * from "./component-df54bc0c.vue?vue&type=script&lang=js&"
import style0 from "./component-df54bc0c.vue?vue&type=style&index=0&id=872f9f52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872f9f52",
  null
  
)

export default component.exports